import React, { useState } from 'react';
import { X, Crown } from 'lucide-react';
import usePiano, { avviaUpgrade } from '../hooks/usePiano';
import './ConfirmModal.css';

// Popup di scelta del piano Pro (mensile/annuale). Self-contained: legge le cadenze
// disponibili da usePiano e avvia il checkout Stripe per quella scelta.
function PlanModal({ open, onClose }) {
  const { cadenze = [], stripeAttivo } = usePiano();
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null); // 'mensile' | 'annuale' | null

  if (!open) return null;

  const scegli = async (cadenza) => {
    setError(null);
    setLoading(cadenza);
    try {
      await avviaUpgrade(cadenza);
    } catch (e) {
      setError(e.response?.data?.errore || e.message);
      setLoading(null);
    }
  };

  // Se /stato non ha (ancora) restituito le cadenze, mostra entrambe come fallback.
  const hasMensile = cadenze.length === 0 || cadenze.includes('mensile');
  const hasAnnuale = cadenze.length === 0 || cadenze.includes('annuale');

  return (
    <div className="modal-overlay" onClick={onClose} role="dialog" aria-modal="true">
      <div className="modal-card" onClick={(e) => e.stopPropagation()}>
        <button type="button" className="modal-close" onClick={onClose} aria-label="Chiudi">
          <X size={20} />
        </button>
        <div className="modal-icon"><Crown size={26} /></div>
        <h3 className="modal-title">Passa a Pro</h3>
        <p className="modal-message">
          Sblocca più schede, foto e listino, e leggi/rispondi ai messaggi dei genitori. Scegli il piano:
        </p>
        {error && <div className="error-message" style={{ marginBottom: '0.75rem' }}>{error}</div>}

        {!stripeAttivo ? (
          <p className="modal-message">Pagamenti non disponibili al momento.</p>
        ) : (
          <div className="plan-options">
            {hasMensile && (
              <button type="button" className="plan-option" onClick={() => scegli('mensile')} disabled={!!loading}>
                <span className="plan-price">€15<span>/mese</span></span>
                <span className="plan-sub">{loading === 'mensile' ? 'Attendi…' : 'Mensile'}</span>
              </button>
            )}
            {hasAnnuale && (
              <button type="button" className="plan-option featured" onClick={() => scegli('annuale')} disabled={!!loading}>
                <span className="plan-badge">2 mesi gratis</span>
                <span className="plan-price">€150<span>/anno</span></span>
                <span className="plan-sub">{loading === 'annuale' ? 'Attendi…' : 'Annuale'}</span>
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default PlanModal;
